<template>
    <div class="vendor">
        <header>
            <div class="container">
                <div class="header__top">
                    <h2 v-if="vendor">{{vendor.text}}
                        <svg v-if="vendor.type == 1" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="icons-/-filled-/-badge-loxone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350"></path>
                            </g>
                        </svg>
                        <svg v-if="vendor.type == 2" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="icons-/-filled-/-badge-vendor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#575C61"></path>
                            </g>
                        </svg>
                    </h2>
                </div>
            </div>
        </header>
        <main>
            <div class="container">
                <div class="plugin__grid plugin__grid--minified">
                    <template v-if="!vendorPlugins">
                        <plugin-entry-placeholder
                            v-for="plugin in 3"
                            :key="plugin"></plugin-entry-placeholder>
                    </template>
                    <template v-else>
                        <plugin-entry
                            v-for="plugin in vendorPlugins" 
                            :key="plugin.id"
                            :id="plugin.id"
                            :logo="plugin.image"
                            :size="96"
                            :title="plugin.name"
                            :short_description="plugin.short_description"
                            :technologies="plugin.technologies"
                            :brands="plugin.brands"
                            :rating="plugin.rating"
                            :creator="plugin.creator"
                            :highlight="plugin.highlight"
                            :certified="plugin.certified"
                            :type="plugin.type"></plugin-entry>
                    </template>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import axios from 'axios';
    import PluginEntry from '@/components/PluginEntry.vue';
    import PluginEntryPlaceholder from '@/components/PluginEntryPlaceholder.vue';

    export default {
        data() {
            return {
                vendorPlugins: null,
                vendor: null,
            }
        },

        components: {
            PluginEntry,
            PluginEntryPlaceholder,
        },

        created() {
            var vendorInfo = new FormData();
            vendorInfo.append('vendor_id', window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1));
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadVendorDetail',
                data: vendorInfo,
            }).then(response => {
                this.vendor = response.data
                
            });

            //Get Highlighted Plugins
            var vendorPlugins = new FormData();
            vendorPlugins.append('filter', JSON.stringify({"creator": [window.location.href.split('/')[4].substring(window.location.href.split('/')[4].lastIndexOf('-') + 1)]}));
            vendorPlugins.append('orderby', 'plugin_downloads');
            vendorPlugins.append('order', 'DESC');
            vendorPlugins.append('limit', '0,200');
            vendorPlugins.append('isFiltered', 'true');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: vendorPlugins,
            }).then(response => {
                this.vendorPlugins = response.data
                });
        },
    }
</script>

<style lang="scss" scoped>
    @import '../scss/utilities/variables';
    @import '../scss/pages/vendor';
</style>